module.exports = __webpack_public_path__ + "static/avatar-borders-do-9149560e365831a0eafcc11deaf85bc9.png";